<app-collapsible-container
    [id]="'taxCertificate'"
    [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.TAX-TITLE'"
    [icon]="'i-file-contract'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <!--Name -->
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.TAX_NAME' | translate }}*</label>
        <app-basic-input
            [formControl]="name"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.TAX_NAME',
                inputId: 'tc-name',
                type: basicInputTypeEnum.TEXT
            }"
            [isValid]="name.valid"
        >
            <app-form-errors *ngIf="name.touched" [errors]="name.errors" (errorDisplay)="elementSizeModification.emit()"></app-form-errors>
        </app-basic-input>
    </div>
    <!-- Quality -->
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.TAX_QUALITY' | translate }}*</label>
        <app-basic-input
            [formControl]="quality"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.TAX_QUALITY',
                inputId: 'tc-quality',
                type: basicInputTypeEnum.TEXT
            }"
            [isValid]="quality.valid"
        >
            <app-form-errors
                *ngIf="quality.touched"
                [errors]="quality.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>
    <!-- Signature -->
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.TAX_SIGNATURE' | translate }}*</label>
        <label class="file-upload btn btn--secondary icon i-upload">
            <input type="file" accept="image/*" (change)="onFileChange($event)" />
            {{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.TAX_SIGNATURE_BTN' | translate }}
        </label>
        <img
            *ngIf="signatureUrl.value"
            [src]="signatureChanged ? signatureUrl.value : environment.base + signatureUrl.value"
            style="max-width: 100%"
            (load)="onImageLoaded()"
            (error)="onImageLoadingError()"
        />
        <app-form-errors
            *ngIf="name.touched && control.errors"
            [errors]="control.errors"
            (errorDisplay)="elementSizeModification.emit()"
        ></app-form-errors>
    </div>
</app-collapsible-container>
